import $ from "jquery";
import Pickr from "pickr-widget";

/* eslint-disable @typescript-eslint/no-this-alias */

export class ColorInput
{
	/**
	 * @private
	 * @type {HTMLElement}
	 */
	button;


	/**
	 * @private
	 * @type {JQuery}
	 */
	$fieldGroup;


	/**
	 * @private
	 * @type {HTMLInputElement}
	 */
	input;


	/**
	 * @param {HTMLElement} button
	 */
	constructor (button)
	{
		this.button = button;
		const $container = $(button).closest(".input-group");

		this.$fieldGroup = $container.closest(".form-group");
		this.input = $container
			.find("input")
			.get(0);
	}


	/**
	 *
	 */
	init ()
	{
		const self = this;

		this.$fieldGroup.on("click", ".pickr", () => this.onOpen());
		$(document).on("form:pickr:open", (event, instance) => this.closeIfOtherPicker(instance));

		Pickr.create({
			default: this.input.value || "fff",
			el: this.button,
			components: {
				preview: true,
				opacity: false,
				hue: true,
				output: {
					hex: true,
					rgba: false,
					hsva: false,
					input: true,
					clear: true,
				},
			},
			strings: {
				save: "Speichern",
				clear: "Leeren",
			},
			onSave (hsva)
			{
				if (null === hsva)
				{
					self.input.value = "";
					return;
				}

				const rgb = hsva.toHEX();
				self.input.value = rgb[0] + rgb[1] + rgb[2];
				self.onClose();
			},
		});
	}


	/**
	 * @private
	 */
	onOpen ()
	{
		this.$fieldGroup.addClass("is-active-field");
		$(document).trigger("form:pickr:open", [this]);
	}


	/**
	 * @private
	 * @param {ColorInput} instance
	 */
	closeIfOtherPicker (instance)
	{
		if (this !== instance)
		{
			this.onClose();
		}
	}

	/**
	 * @private
	 */
	onClose ()
	{
		this.$fieldGroup.removeClass("is-active-field");
	}
}
